export default {
  chatWidget: {
    chatWithUs: 'Discutez avec nous',
    welcomeTitle: 'Bienvenue sur Bookivo!',
    welcomeMessage: 'Comment pouvons-nous vous aider aujourd\'hui?',
    continueChat: 'Continuer la discussion',
    startConversation: 'Commencer la conversation',
    formTitle: 'Parlez-nous de vous',
    namePlaceholder: 'Votre nom',
    emailPlaceholder: 'Votre e-mail',
    phonePlaceholder: 'Votre numéro de téléphone',
    nameRequired: 'Veuillez saisir votre nom',
    emailRequired: 'Veuillez saisir votre e-mail',
    emailInvalid: 'Veuillez saisir une adresse e-mail valide',
    phoneRequired: 'Veuillez saisir votre numéro de téléphone',
    startChat: 'Démarrer le chat',
    chatTitle: 'Chat d\'assistance',
    chatTitleNoAgent: 'Connexion...',
    endChat: 'Terminer le chat',
    inputPlaceholder: 'Tapez votre message...',
    greeting: 'Bonjour',
    greetingMessage: 'Comment puis-je vous aider aujourd\'hui?',
    emoji: 'Emoji',
    uploadImage: 'Télécharger une image',
    sending: 'Envoi en cours...',
    uploadFailed: 'Échec du téléchargement, veuillez réessayer',
    fileTooLarge: 'La taille du fichier ne peut pas dépasser 10 Mo',
    invalidFileType: 'Seuls les fichiers image peuvent être téléchargés',
    sendFailed: 'Échec de l\'envoi du message, veuillez réessayer',
    imageSendFailed: 'Échec de l\'envoi de l\'image, veuillez réessayer',
    connectionLost: 'Connexion perdue, veuillez fermer et rouvrir le chat',
    uploading: 'Téléchargement de l\'image...',
    sessionEnded: 'Session terminée',
    rating: {
      title: 'Merci d\'avoir utilisé notre service. Veuillez évaluer votre expérience !',
      satisfied: 'Satisfait',
      dissatisfied: 'Insatisfait',
      placeholder: 'Bienvenue pour des suggestions',
      submit: 'Soumettre l\'évaluation',
      endChat: 'Terminer le chat',
      backToChat: 'Retourner au chat',
      success: 'Merci pour vos commentaires !'
    }
  }
}
